$(function () {
    var aperture = $(window);
    var carousel = $('.hindle-home-clients .carousel');
    var slides = carousel.find('.slides');
    var prev = carousel.find('.prev');
    var next = carousel.find('.next');
    var dots = carousel.find('.dots');

    if (carousel.length === 0) {
        return;
    }

    // If they do not already exist, create and append the controls
    if (prev.length === 0) {
        prev = $('<a href="#" class="prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" fill="#eb5424" /></svg></a>');
        carousel.append(prev);
    }

    if (next.length === 0) {
        next = $('<a href="#" class="next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" fill="#eb5424" /></svg></a>');
        carousel.append(next);
    }

    if (dots.length === 0) {
        dots = $('<div class="dots"></div>');
        carousel.append(dots);
    }

    // Initialize the carousel
    var init = function () {
        carousel.addClass('-active');
        dots.empty();

        slides.cycle({
            slides: '> .slide',
            fx: 'carousel',
            autoHeight: 'calc',
            prev: prev,
            next: next,
            pager: dots,
            pagerTemplate: '<a href="#" class="dot"><span class="screen-reader-text">{{slideNum}}</span></a>',
            pagerActiveClass: '-active',
            timeout: 8000,
            log: false
        });
    };

    // Start carousel on load
    init();
});
